import { fetchData, postData, patchData, deleteData } from '../utils/api';
import { Account, CreateAccountDto, UpdateAccountDto } from '@/types';

// Account service
const AccountService = {
  // Get all accounts (Super Admin only)
  getAllAccounts: async () => {
    return await fetchData<Account[]>('/admin/accounts');
  },

  // Get account by ID (Super Admin only)
  getAccountById: async (id: string) => {
    return await fetchData<Account>(`/admin/accounts/${id}`);
  },

  // Get own account details
  getOwnAccount: async () => {
    return await fetchData<Account>('/accounts/me');
  },

  // Create a new account (Super Admin only)
  createAccount: async (accountData: CreateAccountDto) => {
    return await postData<Account>('/admin/accounts', accountData);
  },

  // Update account (Super Admin only)
  updateAccount: async (id: string, accountData: UpdateAccountDto) => {
    return await patchData<Account>(`/admin/accounts/${id}`, accountData);
  },

  // Update own account (Channel Admin only)
  updateOwnAccount: async (accountData: UpdateAccountDto) => {
    return await patchData<Account>('/accounts/me', accountData);
  },

  // Archive account (Super Admin only)
  archiveAccount: async (id: string) => {
    return await deleteData<Account>(`/admin/accounts/${id}`);
  },

  // Get account type display name
  getAccountTypeDisplayName: (type: string) => {
    switch (type) {
      case 'BRAND_AMBASSADOR':
        return 'Brand Ambassador';
      case 'CHANNEL_PARTNER':
        return 'Channel Partner';
      case 'INTERNAL':
        return 'Internal';
      default:
        return type;
    }
  },

  // Get account status display name and color
  getAccountStatusInfo: (status: string) => {
    switch (status) {
      case 'ACTIVE':
        return { label: 'Active', color: 'success' };
      case 'SUSPENDED':
        return { label: 'Suspended', color: 'warning' };
      case 'ARCHIVED':
        return { label: 'Archived', color: 'error' };
      default:
        return { label: status, color: 'default' };
    }
  },

  // Get account executive display name
  getAccountExecutiveDisplayName: (executiveName?: string) => {
    if (!executiveName) {
      return 'Not Assigned';
    }
    return executiveName;
  },

  // Get account executive contact info if available
  getAccountExecutiveContacts: (account?: Account | null) => {
    if (!account || !account.accountExecutiveEmail) {
      return null;
    }
    
    return {
      email: account.accountExecutiveEmail,
      phone: account.accountExecutivePhone || null
    };
  },
};

export default AccountService; 